import React from 'react';
import AboutMain from './AboutMain';
import Footer from '../../components/Footer';
import HeaderSeven from '../../components/Header/HeaderSeven';

const About = () => {
  return (
    <>
      <HeaderSeven />

      <AboutMain />

      <Footer />
    </>
  );
};

export default About;
